import passwordValidator from 'password-validator';

enum MB_PASSWORD_UTIL_ERROR_TYPES {
  min = '8-256 characters',
  max = '8-256 characters',
  lowercase = 'At least 1 lowercase letter',
  uppercase = 'At least 1 uppercase letter',
  digits = 'At least 1 number',
  passwordMismatch = 'Passwords match',
  spaces = 'Must not contain spaces',
  unknown = 'Unknow password error',
}

const MB_passwordUtils = {
  validatePassword: (password: string): { errorMessage?: string; errorArray: MB_PASSWORD_UTIL_ERROR_TYPES[] } => {
    const schema = new passwordValidator();
    schema.is().min(8).is().max(256).has().uppercase().has().lowercase().has().digits(1).has().not().spaces().is().not().oneOf([]);

    const validatePassword = schema.validate(password, { list: true });

    let errorMessage = '';
    let errorArray: MB_PASSWORD_UTIL_ERROR_TYPES[] = [];

    if (typeof validatePassword !== 'boolean') {
      if (validatePassword.length === 0) {
        return { errorArray: [] };
      }

      validatePassword.forEach(passwordError => {
        let message = '';

        switch (passwordError) {
          case 'digits': {
            message = 'Password must contain at least one digit';
            errorArray.push(MB_PASSWORD_UTIL_ERROR_TYPES.digits);
            break;
          }
          case 'lowercase': {
            message = 'Password must contain at least one lowercase letter';
            errorArray.push(MB_PASSWORD_UTIL_ERROR_TYPES.lowercase);
            break;
          }
          case 'uppercase': {
            message = 'Password must contain at least one uppercase letter';
            errorArray.push(MB_PASSWORD_UTIL_ERROR_TYPES.uppercase);
            break;
          }
          case 'max': {
            message = 'Password length must not exceed 256 characters';
            errorArray.push(MB_PASSWORD_UTIL_ERROR_TYPES.max);
            break;
          }
          case 'min': {
            message = 'Password length must have at least 8 characters';
            errorArray.push(MB_PASSWORD_UTIL_ERROR_TYPES.min);
            break;
          }
          case 'spaces': {
            message = 'Password must not contain spaces';
            errorArray.push(MB_PASSWORD_UTIL_ERROR_TYPES.spaces);
            break;
          }
          default:
            message = 'Something is wrong with your password. Please try a different password';
            errorArray.push(MB_PASSWORD_UTIL_ERROR_TYPES.unknown);
        }

        if (!errorMessage) {
          errorMessage = message;
        }
      });
    }

    if (!validatePassword) {
      errorMessage = 'Something is wrong with your password. Please try a different password';
    }

    return { errorMessage, errorArray };
  },
};

export { MB_passwordUtils, MB_PASSWORD_UTIL_ERROR_TYPES };
